import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../auth.service';
import { MaterialModule } from '../../material.module';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  standalone: true,
  imports: [MaterialModule, FormsModule, ReactiveFormsModule],
})
export class AuthenticationComponent implements OnInit {
  @Input() autenticationType;
  @Input() showLogin = true;
  @Input() displayTitle = true;

  loginForm: UntypedFormGroup;
  registerForm: UntypedFormGroup;
  loginData;
  isAuthenticated = false;
  loginMessage = '';
  loginErrorMessage;
  signupErrorMessage;
  hide = true;
  captchaSolved = true;
  forgottenEmail;

  constructor(
    public authService: AuthService,
    public location: Location,
    public router: Router,
    private fb: UntypedFormBuilder,
    private toast: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    // this.loginUI
    /* this.loginUI.start("#loginContainer", {
      signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ]
    })
    */
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });

    this.registerForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      lastName: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  setAutenticationType(autenticationType): void {
    this.autenticationType = autenticationType;
  }

  setForgotPass(): void {
    this.setAutenticationType('forgotPass');
  }

  sendPassRecInfo() {
    const destination = this.forgottenEmail;
    this.authService
      .sendPasswordRecoveryEmail(destination)
      .subscribe({
        next: () => {
          this.toast.snackbar.open(this.translate.instant('Snackbar.EmailRecoverySuccess'), 'Ok', { duration: 2000 });
        },
        error: (error) => {
          this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'Ok', {
            duration: 2000,
          });
          console.error(error);
        },
      });
  }

  getErrorMessage() {
    return 'You must enter a value';
  }

  login(formData): void {
    this.authService.checkAccount(formData.email).subscribe(
      () => {
        this.authService
          .login(formData)
          .then(() => this.handleLoginSuccess())
          .catch(() => {
            // console.error(error)
            this.loginErrorMessage = 'Please check your email and password.';
            this.toast.snackbar.open(this.loginErrorMessage, 'ok', {
              duration: 2000,
            });
            /* if (this.loginErrorMessage.length > 0) {
            if (this.loginErrorMessage.includes("confirmation")) {
            }
          } */
          });
      },
      () => {
        this.loginErrorMessage = 'Account unavaible';
        this.toast.snackbar.open(this.translate.instant('Snackbar.Error'), 'ok', {
          duration: 2000,
        });
      }
    );
  }

  signup(formData): void {
    this.authService.signup(formData).subscribe(
      () => {
        this.toast.snackbar.open(this.translate.instant('Snackbar.AccountCreatedSuccess'), 'Ok', { duration: 20000 });
        this.signupErrorMessage = undefined;
        this.handleLoginSuccess();
        setTimeout(() => {
          location.reload();
        }, 3000);
      },
      (error) => {
        if (error.status === 200) {
          this.toast.snackbar.open(this.translate.instant('Snackbar.AccountCreatedSuccess'), 'Ok', { duration: 20000 });
          this.signupErrorMessage = undefined;
          setTimeout(() => {
            location.reload();
          }, 3000);
        }
        console.error(error);
        this.signupErrorMessage = error.error.message;

        this.toast.snackbar.open(this.translate.instant('Snackbar.Error') + ': ' + error.message, 'Ok', { duration: 2000 });
      }
    );
  }

  handleLoginSuccess(): void {
    window.location.reload();
  }

  handleLoginError(error): void {
    return error.error;
  }
}
